import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.visible}}
  <PluginOutlet
    @name="before-user-card-content"
    @outletArgs={{hash user=this.user}}
  />
  <div class="card-content">
    {{#if this.loading}}
      <div class="card-row first-row">
        <div class="user-card-avatar">
          <div
            class="card-avatar-placeholder animated-placeholder placeholder-animation"
          ></div>
        </div>
      </div>

      <div class="card-row second-row">
        <div class="animated-placeholder placeholder-animation"></div>
      </div>
      <div class="card-row">
        <div class="animated-placeholder placeholder-animation"></div>
      </div>
      <div class="card-row">
        <div class="animated-placeholder placeholder-animation"></div>
      </div>
      <div class="card-row">
        <div class="animated-placeholder placeholder-animation"></div>
      </div>
    {{else}}
      <div class="card-row first-row">
        <div class="user-card-avatar">
          {{#if this.contentHidden}}
            <span class="card-huge-avatar">{{bound-avatar
                this.user
                "huge"
              }}</span>
          {{else}}
            <a
              {{on "click" this.handleShowUser}}
              href={{this.user.path}}
              class="card-huge-avatar"
            >{{bound-avatar this.user "huge"}}</a>
          {{/if}}

          <UserAvatarFlair @user={{this.user}} />

          <div>
            <PluginOutlet
              @name="user-card-avatar-flair"
              @connectorTagName="div"
              @outletArgs={{hash user=this.user}}
            />
          </div>
        </div>
        <div class="names">
          <h1
            class="{{this.staff}}
              {{this.newUser}}
              {{if this.nameFirst 'full-name' 'username'}}"
          >
            {{#if this.contentHidden}}
              <span
                id="discourse-user-card-title"
                class="name-username-wrapper"
              >
                {{if
                  this.nameFirst
                  this.user.name
                  (format-username this.user.username)
                }}
              </span>
            {{else}}
              <a
                {{on "click" this.handleShowUser}}
                href={{this.user.path}}
                class="user-profile-link"
              >
                <span
                  id="discourse-user-card-title"
                  class="name-username-wrapper"
                >
                  {{if
                    this.nameFirst
                    this.user.name
                    (format-username this.user.username)
                  }}
                </span>
                {{user-status this.user currentUser=this.currentUser}}
              </a>
            {{/if}}
          </h1>
          <PluginOutlet
            @name="user-card-after-username"
            @connectorTagName="div"
            @outletArgs={{hash user=this.user showUser=this.handleShowUser}}
          />
          {{#if this.nameFirst}}
            <h2 class="username">{{this.user.username}}</h2>
          {{else}}
            {{#if this.user.name}}
              <h2 class="full-name">{{this.user.name}}</h2>
            {{/if}}
          {{/if}}
          {{#if this.user.title}}
            <h2>{{this.user.title}}</h2>
          {{/if}}
          {{#if this.user.staged}}
            <h2 class="staged">{{i18n "user.staged"}}</h2>
          {{/if}}
          {{#if this.hasStatus}}
            <h3 class="user-status">
              {{html-safe this.userStatusEmoji}}
              <span class="user-status__description">
                {{this.user.status.description}}
              </span>
              {{format-date this.user.status.ends_at format="tiny"}}
            </h3>
          {{/if}}
          <div>
            <PluginOutlet
              @name="user-card-post-names"
              @connectorTagName="div"
              @outletArgs={{hash user=this.user}}
            />
          </div>
        </div>
        <ul class="usercard-controls">
          {{#if this.user.can_send_private_message_to_user}}
            <li class="compose-pm">
              <DButton
                @action={{fn (action "composePM") this.user this.post}}
                @icon="envelope"
                @label="user.private_message"
                class="btn-primary"
              />
            </li>
          {{/if}}
          <PluginOutlet
            @name="user-card-below-message-button"
            @connectorTagName="li"
            @outletArgs={{hash user=this.user close=(action "close")}}
          />
          {{#if this.showFilter}}
            <li>
              <DButton
                @action={{fn (action "filterPosts") this.user}}
                @icon="filter"
                @translatedLabel={{this.filterPostsLabel}}
                class="btn-default"
              />
            </li>
          {{/if}}
          {{#if this.hasUserFilters}}
            <li>
              <DButton
                @action={{action "cancelFilter"}}
                @icon="times"
                @label="topic.filters.cancel"
              />
            </li>
          {{/if}}
          {{#if this.showDelete}}
            <li>
              <DButton
                @action={{fn (action "deleteUser") this.user}}
                @icon="exclamation-triangle"
                @label="admin.user.delete"
                class="btn-danger"
              />
            </li>
          {{/if}}
          <PluginOutlet
            @name="user-card-additional-buttons"
            @connectorTagName="li"
            @outletArgs={{hash user=this.user close=(action "close")}}
          />
        </ul>
        <PluginOutlet
          @name="user-card-additional-controls"
          @connectorTagName="div"
          @outletArgs={{hash user=this.user close=(action "close")}}
        />
      </div>

      {{#if this.user.profile_hidden}}
        <div class="card-row second-row">
          <div class="profile-hidden">
            <span>{{i18n "user.profile_hidden"}}</span>
          </div>
        </div>
      {{else if this.user.inactive}}
        <div class="card-row second-row">
          <div class="inactive-user">
            <span>{{i18n "user.inactive_user"}}</span>
          </div>
        </div>
      {{/if}}

      {{#if this.isSuspendedOrHasBio}}
        <div class="card-row second-row">
          {{#if this.user.suspend_reason}}
            <div class="suspended">
              <div class="suspension-date">
                {{d-icon "ban"}}
                {{#if this.user.suspendedForever}}
                  {{i18n "user.suspended_permanently"}}
                {{else}}
                  {{i18n
                    "user.suspended_notice"
                    date=this.user.suspendedTillDate
                  }}
                {{/if}}
              </div>
              <div class="suspension-reason">
                <span class="suspension-reason-title">{{i18n
                    "user.suspended_reason"
                  }}</span>
                <span
                  class="suspension-reason-description"
                >{{this.user.suspend_reason}}</span>
              </div>
            </div>
          {{else}}
            {{#if this.user.bio_excerpt}}
              <div class="bio">
                <HtmlWithLinks>
                  {{html-safe this.user.bio_excerpt}}
                </HtmlWithLinks>
              </div>
            {{/if}}
          {{/if}}
        </div>
      {{/if}}

      {{#if this.showFeaturedTopic}}
        <div class="card-row">
          <div class="featured-topic">
            <span class="desc">{{i18n "user.featured_topic"}}</span>
            <LinkTo
              @route="topic"
              @models={{array
                this.user.featured_topic.slug
                this.user.featured_topic.id
              }}
            >{{replace-emoji
                (html-safe this.user.featured_topic.fancy_title)
              }}</LinkTo>
          </div>
        </div>
      {{/if}}

      {{#if this.hasLocaleOrWebsite}}
        <div class="card-row">
          <div class="location-and-website">
            {{#if this.user.website_name}}
              <span class="website-name">
                {{d-icon "globe"}}
                {{#if this.linkWebsite}}
                  {{! template-lint-disable link-rel-noopener }}
                  <a
                    href={{this.user.website}}
                    rel="noopener {{unless this.removeNoFollow 'nofollow ugc'}}"
                    target="_blank"
                  >{{this.user.website_name}}</a>
                  {{! template-lint-enable link-rel-noopener }}
                {{else}}
                  <span
                    title={{this.user.website}}
                  >{{this.user.website_name}}</span>
                {{/if}}
              </span>
            {{/if}}
            {{#if this.user.location}}
              <span class="location">
                {{d-icon "map-marker-alt"}}
                <span>{{this.user.location}}</span>
              </span>
            {{/if}}
            {{#if this.showUserLocalTime}}
              <span class="local-time" title={{i18n "local_time"}}>
                {{d-icon "far-clock"}}
                <span>{{this.formattedUserLocalTime}}</span>
              </span>
            {{/if}}
            <span>
              <PluginOutlet
                @name="user-card-location-and-website"
                @connectorTagName="div"
                @outletArgs={{hash user=this.user}}
              />
            </span>
          </div>
        </div>
      {{/if}}

      <div class="card-row metadata-row">
        {{#unless this.contentHidden}}
          <div class="metadata">
            {{#if this.user.last_posted_at}}
              <h3><span class="desc">{{i18n "last_post"}}</span>
                {{format-date this.user.last_posted_at leaveAgo="true"}}</h3>
            {{/if}}
            <h3><span class="desc">{{i18n "joined"}}</span>
              {{format-date this.user.created_at leaveAgo="true"}}</h3>
            {{#if this.user.time_read}}
              <h3 title={{this.timeReadTooltip}}>
                <span class="desc">{{i18n "time_read"}}</span>
                {{format-duration this.user.time_read}}
                {{#if this.showRecentTimeRead}}
                  <span>({{i18n
                      "time_read_recently"
                      time_read=this.recentTimeRead
                    }})</span>
                {{/if}}
              </h3>
            {{/if}}
            {{#if this.showCheckEmail}}
              <h3 class="email">
                {{d-icon "envelope" title="user.email.title"}}
                {{#if this.user.email}}
                  {{this.user.email}}
                {{else}}
                  <DButton
                    @action={{fn (action "checkEmail") this.user}}
                    @icon="envelope"
                    @label="admin.users.check_email.text"
                    class="btn-primary"
                  />
                {{/if}}
              </h3>
            {{/if}}
            <PluginOutlet
              @name="user-card-metadata"
              @connectorTagName="div"
              @outletArgs={{hash user=this.user}}
            />
          </div>
        {{/unless}}
        <PluginOutlet
          @name="user-card-after-metadata"
          @connectorTagName="div"
          @outletArgs={{hash user=this.user}}
        />
      </div>

      {{#if this.publicUserFields}}
        <div class="card-row">
          <div class="public-user-fields">
            {{#each this.publicUserFields as |uf|}}
              {{#if uf.value}}
                <div
                  class="public-user-field public-user-field__{{uf.field.dasherized_name}}"
                >
                  <span class="user-field-name">{{uf.field.name}}:</span>
                  <span class="user-field-value">
                    {{#each uf.value as |v|}}
                      {{! some values are arrays }}
                      <span class="user-field-value-list-item">{{v}}</span>
                    {{else}}
                      {{uf.value}}
                    {{/each}}
                  </span>
                </div>
              {{/if}}
            {{/each}}
          </div>
        </div>
      {{/if}}

      <PluginOutlet
        @name="user-card-before-badges"
        @connectorTagName="div"
        @outletArgs={{hash user=this.user}}
      />

      {{#if this.showBadges}}
        <div class="card-row">
          {{#if this.user.featured_user_badges}}
            <div class="badge-section">
              {{#each this.user.featured_user_badges as |ub|}}
                <UserBadge @badge={{ub.badge}} @user={{this.user}} />
              {{/each}}
              {{#if this.showMoreBadges}}
                <span class="more-user-badges">
                  <LinkTo @route="user.badges" @model={{this.user}}>
                    {{i18n "badges.more_badges" count=this.moreBadgesCount}}
                  </LinkTo>
                </span>
              {{/if}}
            </div>
          {{/if}}
        </div>
      {{/if}}
    {{/if}}
  </div>
{{/if}}
*/
{
  "id": "Zbe1Nh8e",
  "block": "[[[41,[30,0,[\"visible\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@name\",\"@outletArgs\"],[\"before-user-card-content\",[28,[37,2],null,[[\"user\"],[[30,0,[\"user\"]]]]]]],null],[1,\"\\n  \"],[10,0],[14,0,\"card-content\"],[12],[1,\"\\n\"],[41,[30,0,[\"loading\"]],[[[1,\"      \"],[10,0],[14,0,\"card-row first-row\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"user-card-avatar\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"card-avatar-placeholder animated-placeholder placeholder-animation\"],[12],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"card-row second-row\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"animated-placeholder placeholder-animation\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"card-row\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"animated-placeholder placeholder-animation\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"card-row\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"animated-placeholder placeholder-animation\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"card-row\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"animated-placeholder placeholder-animation\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,0,\"card-row first-row\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"user-card-avatar\"],[12],[1,\"\\n\"],[41,[30,0,[\"contentHidden\"]],[[[1,\"            \"],[10,1],[14,0,\"card-huge-avatar\"],[12],[1,[28,[35,3],[[30,0,[\"user\"]],\"huge\"],null]],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[11,3],[16,6,[30,0,[\"user\",\"path\"]]],[24,0,\"card-huge-avatar\"],[4,[38,4],[\"click\",[30,0,[\"handleShowUser\"]]],null],[12],[1,[28,[35,3],[[30,0,[\"user\"]],\"huge\"],null]],[13],[1,\"\\n\"]],[]]],[1,\"\\n          \"],[8,[39,5],null,[[\"@user\"],[[30,0,[\"user\"]]]],null],[1,\"\\n\\n          \"],[10,0],[12],[1,\"\\n            \"],[8,[39,1],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"user-card-avatar-flair\",\"div\",[28,[37,2],null,[[\"user\"],[[30,0,[\"user\"]]]]]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"names\"],[12],[1,\"\\n          \"],[10,\"h1\"],[15,0,[29,[[30,0,[\"staff\"]],\"\\n              \",[30,0,[\"newUser\"]],\"\\n              \",[52,[30,0,[\"nameFirst\"]],\"full-name\",\"username\"]]]],[12],[1,\"\\n\"],[41,[30,0,[\"contentHidden\"]],[[[1,\"              \"],[10,1],[14,1,\"discourse-user-card-title\"],[14,0,\"name-username-wrapper\"],[12],[1,\"\\n                \"],[1,[52,[30,0,[\"nameFirst\"]],[30,0,[\"user\",\"name\"]],[28,[37,6],[[30,0,[\"user\",\"username\"]]],null]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],[[[1,\"              \"],[11,3],[16,6,[30,0,[\"user\",\"path\"]]],[24,0,\"user-profile-link\"],[4,[38,4],[\"click\",[30,0,[\"handleShowUser\"]]],null],[12],[1,\"\\n                \"],[10,1],[14,1,\"discourse-user-card-title\"],[14,0,\"name-username-wrapper\"],[12],[1,\"\\n                  \"],[1,[52,[30,0,[\"nameFirst\"]],[30,0,[\"user\",\"name\"]],[28,[37,6],[[30,0,[\"user\",\"username\"]]],null]]],[1,\"\\n                \"],[13],[1,\"\\n                \"],[1,[28,[35,7],[[30,0,[\"user\"]]],[[\"currentUser\"],[[30,0,[\"currentUser\"]]]]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n          \"],[8,[39,1],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"user-card-after-username\",\"div\",[28,[37,2],null,[[\"user\",\"showUser\"],[[30,0,[\"user\"]],[30,0,[\"handleShowUser\"]]]]]]],null],[1,\"\\n\"],[41,[30,0,[\"nameFirst\"]],[[[1,\"            \"],[10,\"h2\"],[14,0,\"username\"],[12],[1,[30,0,[\"user\",\"username\"]]],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"user\",\"name\"]],[[[1,\"              \"],[10,\"h2\"],[14,0,\"full-name\"],[12],[1,[30,0,[\"user\",\"name\"]]],[13],[1,\"\\n\"]],[]],null]],[]]],[41,[30,0,[\"user\",\"title\"]],[[[1,\"            \"],[10,\"h2\"],[12],[1,[30,0,[\"user\",\"title\"]]],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"user\",\"staged\"]],[[[1,\"            \"],[10,\"h2\"],[14,0,\"staged\"],[12],[1,[28,[35,8],[\"user.staged\"],null]],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"hasStatus\"]],[[[1,\"            \"],[10,\"h3\"],[14,0,\"user-status\"],[12],[1,\"\\n              \"],[1,[28,[35,9],[[30,0,[\"userStatusEmoji\"]]],null]],[1,\"\\n              \"],[10,1],[14,0,\"user-status__description\"],[12],[1,\"\\n                \"],[1,[30,0,[\"user\",\"status\",\"description\"]]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[1,[28,[35,10],[[30,0,[\"user\",\"status\",\"ends_at\"]]],[[\"format\"],[\"tiny\"]]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[10,0],[12],[1,\"\\n            \"],[8,[39,1],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"user-card-post-names\",\"div\",[28,[37,2],null,[[\"user\"],[[30,0,[\"user\"]]]]]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"ul\"],[14,0,\"usercard-controls\"],[12],[1,\"\\n\"],[41,[30,0,[\"user\",\"can_send_private_message_to_user\"]],[[[1,\"            \"],[10,\"li\"],[14,0,\"compose-pm\"],[12],[1,\"\\n              \"],[8,[39,11],[[24,0,\"btn-primary\"]],[[\"@action\",\"@icon\",\"@label\"],[[28,[37,12],[[28,[37,13],[[30,0],\"composePM\"],null],[30,0,[\"user\"]],[30,0,[\"post\"]]],null],\"envelope\",\"user.private_message\"]],null],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[8,[39,1],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"user-card-below-message-button\",\"li\",[28,[37,2],null,[[\"user\",\"close\"],[[30,0,[\"user\"]],[28,[37,13],[[30,0],\"close\"],null]]]]]],null],[1,\"\\n\"],[41,[30,0,[\"showFilter\"]],[[[1,\"            \"],[10,\"li\"],[12],[1,\"\\n              \"],[8,[39,11],[[24,0,\"btn-default\"]],[[\"@action\",\"@icon\",\"@translatedLabel\"],[[28,[37,12],[[28,[37,13],[[30,0],\"filterPosts\"],null],[30,0,[\"user\"]]],null],\"filter\",[30,0,[\"filterPostsLabel\"]]]],null],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"hasUserFilters\"]],[[[1,\"            \"],[10,\"li\"],[12],[1,\"\\n              \"],[8,[39,11],null,[[\"@action\",\"@icon\",\"@label\"],[[28,[37,13],[[30,0],\"cancelFilter\"],null],\"times\",\"topic.filters.cancel\"]],null],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"showDelete\"]],[[[1,\"            \"],[10,\"li\"],[12],[1,\"\\n              \"],[8,[39,11],[[24,0,\"btn-danger\"]],[[\"@action\",\"@icon\",\"@label\"],[[28,[37,12],[[28,[37,13],[[30,0],\"deleteUser\"],null],[30,0,[\"user\"]]],null],\"exclamation-triangle\",\"admin.user.delete\"]],null],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[8,[39,1],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"user-card-additional-buttons\",\"li\",[28,[37,2],null,[[\"user\",\"close\"],[[30,0,[\"user\"]],[28,[37,13],[[30,0],\"close\"],null]]]]]],null],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,1],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"user-card-additional-controls\",\"div\",[28,[37,2],null,[[\"user\",\"close\"],[[30,0,[\"user\"]],[28,[37,13],[[30,0],\"close\"],null]]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"user\",\"profile_hidden\"]],[[[1,\"        \"],[10,0],[14,0,\"card-row second-row\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"profile-hidden\"],[12],[1,\"\\n            \"],[10,1],[12],[1,[28,[35,8],[\"user.profile_hidden\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"user\",\"inactive\"]],[[[1,\"        \"],[10,0],[14,0,\"card-row second-row\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"inactive-user\"],[12],[1,\"\\n            \"],[10,1],[12],[1,[28,[35,8],[\"user.inactive_user\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]],null]],[]]],[1,\"\\n\"],[41,[30,0,[\"isSuspendedOrHasBio\"]],[[[1,\"        \"],[10,0],[14,0,\"card-row second-row\"],[12],[1,\"\\n\"],[41,[30,0,[\"user\",\"suspend_reason\"]],[[[1,\"            \"],[10,0],[14,0,\"suspended\"],[12],[1,\"\\n              \"],[10,0],[14,0,\"suspension-date\"],[12],[1,\"\\n                \"],[1,[28,[35,14],[\"ban\"],null]],[1,\"\\n\"],[41,[30,0,[\"user\",\"suspendedForever\"]],[[[1,\"                  \"],[1,[28,[35,8],[\"user.suspended_permanently\"],null]],[1,\"\\n\"]],[]],[[[1,\"                  \"],[1,[28,[35,8],[\"user.suspended_notice\"],[[\"date\"],[[30,0,[\"user\",\"suspendedTillDate\"]]]]]],[1,\"\\n\"]],[]]],[1,\"              \"],[13],[1,\"\\n              \"],[10,0],[14,0,\"suspension-reason\"],[12],[1,\"\\n                \"],[10,1],[14,0,\"suspension-reason-title\"],[12],[1,[28,[35,8],[\"user.suspended_reason\"],null]],[13],[1,\"\\n                \"],[10,1],[14,0,\"suspension-reason-description\"],[12],[1,[30,0,[\"user\",\"suspend_reason\"]]],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"user\",\"bio_excerpt\"]],[[[1,\"              \"],[10,0],[14,0,\"bio\"],[12],[1,\"\\n                \"],[8,[39,15],null,null,[[\"default\"],[[[[1,\"\\n                  \"],[1,[28,[35,9],[[30,0,[\"user\",\"bio_excerpt\"]]],null]],[1,\"\\n                \"]],[]]]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null]],[]]],[1,\"        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showFeaturedTopic\"]],[[[1,\"        \"],[10,0],[14,0,\"card-row\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"featured-topic\"],[12],[1,\"\\n            \"],[10,1],[14,0,\"desc\"],[12],[1,[28,[35,8],[\"user.featured_topic\"],null]],[13],[1,\"\\n            \"],[8,[39,16],null,[[\"@route\",\"@models\"],[\"topic\",[28,[37,17],[[30,0,[\"user\",\"featured_topic\",\"slug\"]],[30,0,[\"user\",\"featured_topic\",\"id\"]]],null]]],[[\"default\"],[[[[1,[28,[35,18],[[28,[37,9],[[30,0,[\"user\",\"featured_topic\",\"fancy_title\"]]],null]],null]]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"hasLocaleOrWebsite\"]],[[[1,\"        \"],[10,0],[14,0,\"card-row\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"location-and-website\"],[12],[1,\"\\n\"],[41,[30,0,[\"user\",\"website_name\"]],[[[1,\"              \"],[10,1],[14,0,\"website-name\"],[12],[1,\"\\n                \"],[1,[28,[35,14],[\"globe\"],null]],[1,\"\\n\"],[41,[30,0,[\"linkWebsite\"]],[[[1,\"                  \"],[10,3],[15,6,[30,0,[\"user\",\"website\"]]],[15,\"rel\",[29,[\"noopener \",[52,[51,[30,0,[\"removeNoFollow\"]]],\"nofollow ugc\"]]]],[14,\"target\",\"_blank\"],[12],[1,[30,0,[\"user\",\"website_name\"]]],[13],[1,\"\\n\"]],[]],[[[1,\"                  \"],[10,1],[15,\"title\",[30,0,[\"user\",\"website\"]]],[12],[1,[30,0,[\"user\",\"website_name\"]]],[13],[1,\"\\n\"]],[]]],[1,\"              \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"user\",\"location\"]],[[[1,\"              \"],[10,1],[14,0,\"location\"],[12],[1,\"\\n                \"],[1,[28,[35,14],[\"map-marker-alt\"],null]],[1,\"\\n                \"],[10,1],[12],[1,[30,0,[\"user\",\"location\"]]],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"showUserLocalTime\"]],[[[1,\"              \"],[10,1],[14,0,\"local-time\"],[15,\"title\",[28,[37,8],[\"local_time\"],null]],[12],[1,\"\\n                \"],[1,[28,[35,14],[\"far-clock\"],null]],[1,\"\\n                \"],[10,1],[12],[1,[30,0,[\"formattedUserLocalTime\"]]],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"            \"],[10,1],[12],[1,\"\\n              \"],[8,[39,1],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"user-card-location-and-website\",\"div\",[28,[37,2],null,[[\"user\"],[[30,0,[\"user\"]]]]]]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n      \"],[10,0],[14,0,\"card-row metadata-row\"],[12],[1,\"\\n\"],[41,[51,[30,0,[\"contentHidden\"]]],[[[1,\"          \"],[10,0],[14,0,\"metadata\"],[12],[1,\"\\n\"],[41,[30,0,[\"user\",\"last_posted_at\"]],[[[1,\"              \"],[10,\"h3\"],[12],[10,1],[14,0,\"desc\"],[12],[1,[28,[35,8],[\"last_post\"],null]],[13],[1,\"\\n                \"],[1,[28,[35,10],[[30,0,[\"user\",\"last_posted_at\"]]],[[\"leaveAgo\"],[\"true\"]]]],[13],[1,\"\\n\"]],[]],null],[1,\"            \"],[10,\"h3\"],[12],[10,1],[14,0,\"desc\"],[12],[1,[28,[35,8],[\"joined\"],null]],[13],[1,\"\\n              \"],[1,[28,[35,10],[[30,0,[\"user\",\"created_at\"]]],[[\"leaveAgo\"],[\"true\"]]]],[13],[1,\"\\n\"],[41,[30,0,[\"user\",\"time_read\"]],[[[1,\"              \"],[10,\"h3\"],[15,\"title\",[30,0,[\"timeReadTooltip\"]]],[12],[1,\"\\n                \"],[10,1],[14,0,\"desc\"],[12],[1,[28,[35,8],[\"time_read\"],null]],[13],[1,\"\\n                \"],[1,[28,[35,20],[[30,0,[\"user\",\"time_read\"]]],null]],[1,\"\\n\"],[41,[30,0,[\"showRecentTimeRead\"]],[[[1,\"                  \"],[10,1],[12],[1,\"(\"],[1,[28,[35,8],[\"time_read_recently\"],[[\"time_read\"],[[30,0,[\"recentTimeRead\"]]]]]],[1,\")\"],[13],[1,\"\\n\"]],[]],null],[1,\"              \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"showCheckEmail\"]],[[[1,\"              \"],[10,\"h3\"],[14,0,\"email\"],[12],[1,\"\\n                \"],[1,[28,[35,14],[\"envelope\"],[[\"title\"],[\"user.email.title\"]]]],[1,\"\\n\"],[41,[30,0,[\"user\",\"email\"]],[[[1,\"                  \"],[1,[30,0,[\"user\",\"email\"]]],[1,\"\\n\"]],[]],[[[1,\"                  \"],[8,[39,11],[[24,0,\"btn-primary\"]],[[\"@action\",\"@icon\",\"@label\"],[[28,[37,12],[[28,[37,13],[[30,0],\"checkEmail\"],null],[30,0,[\"user\"]]],null],\"envelope\",\"admin.users.check_email.text\"]],null],[1,\"\\n\"]],[]]],[1,\"              \"],[13],[1,\"\\n\"]],[]],null],[1,\"            \"],[8,[39,1],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"user-card-metadata\",\"div\",[28,[37,2],null,[[\"user\"],[[30,0,[\"user\"]]]]]]],null],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[8,[39,1],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"user-card-after-metadata\",\"div\",[28,[37,2],null,[[\"user\"],[[30,0,[\"user\"]]]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"publicUserFields\"]],[[[1,\"        \"],[10,0],[14,0,\"card-row\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"public-user-fields\"],[12],[1,\"\\n\"],[42,[28,[37,22],[[28,[37,22],[[30,0,[\"publicUserFields\"]]],null]],null],null,[[[41,[30,1,[\"value\"]],[[[1,\"                \"],[10,0],[15,0,[29,[\"public-user-field public-user-field__\",[30,1,[\"field\",\"dasherized_name\"]]]]],[12],[1,\"\\n                  \"],[10,1],[14,0,\"user-field-name\"],[12],[1,[30,1,[\"field\",\"name\"]]],[1,\":\"],[13],[1,\"\\n                  \"],[10,1],[14,0,\"user-field-value\"],[12],[1,\"\\n\"],[42,[28,[37,22],[[28,[37,22],[[30,1,[\"value\"]]],null]],null],null,[[[1,\"                      \"],[10,1],[14,0,\"user-field-value-list-item\"],[12],[1,[30,2]],[13],[1,\"\\n\"]],[2]],[[[1,\"                      \"],[1,[30,1,[\"value\"]]],[1,\"\\n\"]],[]]],[1,\"                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],null]],[1]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n      \"],[8,[39,1],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"user-card-before-badges\",\"div\",[28,[37,2],null,[[\"user\"],[[30,0,[\"user\"]]]]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"showBadges\"]],[[[1,\"        \"],[10,0],[14,0,\"card-row\"],[12],[1,\"\\n\"],[41,[30,0,[\"user\",\"featured_user_badges\"]],[[[1,\"            \"],[10,0],[14,0,\"badge-section\"],[12],[1,\"\\n\"],[42,[28,[37,22],[[28,[37,22],[[30,0,[\"user\",\"featured_user_badges\"]]],null]],null],null,[[[1,\"                \"],[8,[39,23],null,[[\"@badge\",\"@user\"],[[30,3,[\"badge\"]],[30,0,[\"user\"]]]],null],[1,\"\\n\"]],[3]],null],[41,[30,0,[\"showMoreBadges\"]],[[[1,\"                \"],[10,1],[14,0,\"more-user-badges\"],[12],[1,\"\\n                  \"],[8,[39,16],null,[[\"@route\",\"@model\"],[\"user.badges\",[30,0,[\"user\"]]]],[[\"default\"],[[[[1,\"\\n                    \"],[1,[28,[35,8],[\"badges.more_badges\"],[[\"count\"],[[30,0,[\"moreBadgesCount\"]]]]]],[1,\"\\n                  \"]],[]]]]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n\"]],[]],null]],[]]],[1,\"  \"],[13],[1,\"\\n\"]],[]],null]],[\"uf\",\"v\",\"ub\"],false,[\"if\",\"plugin-outlet\",\"hash\",\"bound-avatar\",\"on\",\"user-avatar-flair\",\"format-username\",\"user-status\",\"i18n\",\"html-safe\",\"format-date\",\"d-button\",\"fn\",\"action\",\"d-icon\",\"html-with-links\",\"link-to\",\"array\",\"replace-emoji\",\"unless\",\"format-duration\",\"each\",\"-track-array\",\"user-badge\"]]",
  "moduleName": "discourse/components/user-card-contents.hbs",
  "isStrictMode": false
});